<template>
    <div class="reservation-box">
        <div class="header">
            <slot name="header" />
        </div>

        <slot />
    </div>
</template>

<script lang="ts" setup>

</script>
